import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle
} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-confirmation',
    templateUrl: './modal-confirmation.component.html',
    styleUrls: ['./modal-confirmation.component.scss'],
    imports: [CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, MatDialogTitle]
})
export class ModalConfirmationComponent implements OnInit, OnDestroy {
    data = inject(MAT_DIALOG_DATA);
    private translateService = inject(TranslateService);

    content = 'Êtes-vous sur de vouloir effectuer cette action ?';
    cancel = 'Non';
    confirm = 'Oui';
    private subscriptions: Subscription[] = [];

    constructor() {
        const data = this.data;

        if (
            data != undefined &&
            data.content != undefined &&
            data.content != ''
        ) {
            this.content = data.content;
        } else {
            this.subscriptions.push( this.translateService.get('general.modaleConfirmerAction').subscribe(res => this.content = res) );
        }

        if (data != undefined && data.cancel != undefined && data.cancel != ''){
            this.cancel = data.cancel;
        }
        else{
            this.subscriptions.push( this.translateService.get('general.non').subscribe(res => this.cancel = res) );
        }

        if (data != undefined && data.confirm != undefined && data.confirm != ''){
            this.confirm = data.confirm;
        }
        else{
            this.subscriptions.push( this.translateService.get('general.oui').subscribe(res => this.confirm = res) );
        }

    }

    ngOnInit() {}
    ngOnDestroy(): void {
        this.subscriptions.forEach(item => item.unsubscribe());
    }
}
